import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronLeftMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChevronLeftMedium"><Path d="M14.5 18.5L8 12L14.5 5.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconChevronLeftMedium;
